import { selectSelectedEntitiesCount } from './selectSelectedEntitiesCount';
import { IApplicationState } from '../../types/redux';

export const selectIsAllEntitiesSelected = (state: IApplicationState) => {
  const selectedCount = selectSelectedEntitiesCount(state);

  return selectedCount === state.results.favoriteEntities.length;
};
